<template>
  <page-wrapper :title="pageWrapper.title" :has-pad="pageWrapper.hasPad">
    <loading-overlay :active="isLoading" />
    <div class="header text-end">
      <sc-button :route="{ name: 'BannerPinnedPage' }" variant="secondary">จัดลำดับการแสดงผล</sc-button>
    </div>
    <nav-tabs
      :tabs="tabs"
      :current-index="currentIndex"
      @change-tab="handleChangeTab"
    ></nav-tabs>
    <banner-list-item
      v-for="banner in currentBanners"
      :id="banner.id"
      :key="banner.id"
      :image-url="banner.imageUrl"
      :title="banner.title"
      :content="banner.content"
      :category="banner.category"
      :is-pin="banner.isPinned"
      @onDelete="handleDelete(banner)"
    ></banner-list-item>
    <confirm-dialog
      v-if="deleteDialog.isShow"
      :data="deleteDialog"
      @confirm="handleConfirmDeleteDialog"
    ></confirm-dialog>
    <div class="wrapper text-end padding-adjust">
      <el-pagination
        :total="total"
        :page-size="10"
        :current-page="queryParams.page"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import LoadingOverlay from "@/lib/components/LoadingOverlay";
import { Pagination } from "element-ui";
import { articleUseCase } from "../../../dependencies";
import NavTabs from "../../../lib/components/NavTabs";
import PageWrapper from "../../../lib/components/PageWrapper";
import BannerListItem from "../components/BannerListItem";

export default {
  components: {
    PageWrapper,
    NavTabs,
    BannerListItem,
    ScButton,
    LoadingOverlay,
    "el-pagination": Pagination
  },
  data() {
    const pageWrapper = {
      title: "แบนเนอร์",
      hasPad: false
    };

    const categories = [
      { key: "all", title: "ทั้งหมด" },
      { key: "news", title: "ข่าวประชาสัมพันธ์" },
      { key: "activities", title: "ข่าวกิจกรรม" },
      { key: "privileges", title: "ข่าวสิทธิพิเศษ" }
    ];

    const deleteDialog = {
      isShow: false,
      title: "",
      detail: "คุณแน่ใจหรือไม่ว่าต้องการลบแบนเนอร์นี้ ?",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "ลบ"
    };

    const banners = [];
    const selectedBanner = null;
    const counts = {
      all: 0,
      news: 0,
      activities: 0,
      privileges: 0
    };

    return {
      pageWrapper,
      categories,
      deleteDialog,
      selectedBanner,
      banners,
      counts,
      isLoading: false
    };
  },
  computed: {
    currentCategory() {
      return this.$route.query.category || "all";
    },
    total() {
      return this.counts[this.currentCategory];
    },
    tabs() {
      return this.categories.map(({ key, title }) => {
        const count = this.counts[key];

        return { title, count };
      });
    },
    currentIndex() {
      return this.categories.findIndex(
        ({ key }) => this.currentCategory === key
      );
    },
    currentBanners() {
      return this.banners;
    },
    queryParams() {
      return {
        articleTypeKeyword: this.currentCategory || "",
        page: parseInt(this.$route.query.page, 10) || 1
      };
    }
  },
  watch: {
    $route(to) {
      const needUpdateTab = to.name === "BannerList";

      if (!needUpdateTab) {
        return;
      }

      const { category } = to.query;

      this.updateTabByCategory(category);
      this.setupBannerData();
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      this.setupCurrentCategory();
      await this.setupBannerData();
    },
    setupCurrentCategory() {
      const { category = "all" } = this.$route.query;

      this.updateTabByCategory(category);
    },
    async setupBannerData() {
      this.isLoading = true;
      const { articleBanners, count } = await articleUseCase.listBanner(
        this.queryParams
      );

      this.banners = articleBanners;
      this.counts[this.queryParams.articleTypeKeyword || "all"] = count;
      this.isLoading = false;
    },
    handleChangeTab(index) {
      const category = this.categories[index].key;

      this.$router.push({ name: "BannerList", query: { category, page: 1 } });
    },
    updateTabByCategory(category) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, category }
      };

      this.$router.replace(route).catch(err => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      });
    },
    handleDelete(banner) {
      this.deleteDialog.isShow = true;
      this.selectedBanner = banner;
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route).catch(err => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      });
    },
    async handleConfirmDeleteDialog(isConfirm) {
      if (!isConfirm) {
        this.deleteDialog.isShow = false;
        this.selectedBanner = undefined;
        return;
      }

      const {id} = this.selectedBanner;
      await this.deleteBanner(id);
      await this.setupBannerData();

      this.selectedBanner = undefined;
      this.deleteDialog.isShow = false;
    },
    async deleteBanner(id) {
      await articleUseCase.deleteBanner(id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.header {
  justify-content: space-between;
  padding: 10px;
  background: #f9f9f9;
}
.padding-adjust {
  padding: 10px 0;
}
</style>
